
import styled from 'styled-components';

export const Container = styled.div`

    padding: 10px;
    margin-top: -10px;

    h3 {
        margin-bottom: 20px;
    }
    
    @media(max-width: 450px) {
        padding: 10px;
    }
        
    .div-movies {
        position: relative;
        display: flex;
        margin: 15px 0 20px 0;
        padding-right: 20px;
    }

    .div-movies::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        width: 20px;
        height: 100%;
        background-image: linear-gradient(to left,#202020 60%,rgba(24,24,24,0) 100%);
        z-index: 1;
    }


`;

export const ServiceGridContainer = styled.div`
    display: flex;
    max-width: 100dvw;
    overflow-x: auto;
`;

export const SubTitle = styled.h2`

    display: flex;
    align-items: center;

    margin: 0 0 5px 10px;

    img {
        width: 40px;
        margin-left: 10px;
    }
    
    @media (max-width: 600px) {
        margin-left: 5px;
        font-size: 1rem;

        img {
            width: 30px;
            margin-left: 5px;
        }
    }

`;

export const LoadMoreButton = styled.button`
    grid-column: 1 / -1;
    padding: 10px 20px;
    background-color: #007BFF;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin: 20px auto;
    display: block;
    width: fit-content;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #0056b3;
    }
`;

export const LoadingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70vh;
    width: 100%;
    padding: 100px;
    margin: auto;
`;

export const NoService = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    width: 100%;

    a {
        padding: 12px;
        background-color: #007bff;
        color: white;
        border: none;
        border-radius: 4px;
        text-decoration: none;
        font-size: 1rem;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    a:hover {
        background-color: #0056b3;
    }

`

export const NoServicesMessage = styled.p`
    font-size: 1rem;
    color: #666;
    text-align: center;
    padding: 20px;
`;

export const StatusContainer = styled.div`
    margin-bottom: 20px;
`;

export const ButtonStatus = styled.button`
    padding: 10px;
    margin-right: 5px;
    border-radius: 5px;
    background: ${props => props.active ? '#000' : 'none'};
    color: ${props => props.active ? '#fff' : '000'};
    border: 2px solid #505050;
    transition: all .3s ease;

    &:hover {
        background: ${props => props.active ? '#000' : '#ddd'};
    }
`;
